import "../scss/style.css";

function Copyright() {
  return (
    <div className="copyRight">
      Petius of Warcraft - Belfu <span>© 2021</span>
    </div>
  );
}

export default Copyright;
